
import { Component, Prop, Vue, Provide, Inject } from 'vue-property-decorator'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
@Observer
@Component({
  components: {}
})
export default class extends Vue {
  get PageStore() {
    return this.$store.$menu
  }
  onSubmit() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
